import { postGetActivityDetails } from "@/api/clientApi/activity.ts";
import {
  filterLoginTargetsState,
  filterNoLoginTargetsState,
} from "@/constants/constants.ts";
import { useConfigRestrict } from "@/hooks/useConfigRestrict.ts";
import { userStore } from "@/stores/userStore.ts";

import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import {
  ActivityDetailStatus,
  ActivityTypeEnum,
  CompType,
  LoginType,
  RechargeType,
} from "../base/baseEnum";

/** 活动组件属性接口 */
export interface ActivityBannerAttrs extends BaseComponentAttrs {
  /** 活动类型 */
  atype: number;
  /** 标题类型 */
  title_type: number;
  /** 标题图标 */
  title_icon: string;
}

/** 活动轮播图组件类 */
export class ActivityBannerComponent extends BaseComponent<ActivityBannerAttrs> {
  constructor(data: Partial<BaseComponent<ActivityBannerAttrs>> = {}) {
    super(data);
    this.type = CompType.activity_banner;
  }

  /** 获取轮播图数据列表 */
  public async getBannerItems() {
    const { getStatusByDeny } = useConfigRestrict();
    // 排除活动逻辑在这写
    const filterLoginTargets = filterLoginTargetsState;
    const filterNoLoginTargets = filterNoLoginTargetsState;
    // 需要过滤的活动列表
    const limitBase = userStore.isLogin
      ? filterLoginTargets
      : filterNoLoginTargets;
    const filterActivity = limitBase.filter((filterItem) =>
      this.lang_attrs?.list?.some(
        (listItem: {
          status: boolean;
          related_activity: ActivityTypeEnum;
          click_params: string;
        }) =>
          listItem?.status &&
          listItem?.a_type === filterItem.atype &&
          listItem?.click_params?.includes(filterItem.click_params),
      ),
    );
    const filterAtypes: Record<number, boolean> = {};
    //有需要判断时进入判断
    if (filterActivity.length > 0) {
      if (userStore.isLogin) {
        // 需要过滤活动，请求活动status
        const details = await postGetActivityDetails(
          { atypes: filterActivity.map((item) => item.atype) },
          false,
        );
        const activeStatus: Record<number, boolean> = {
          [ActivityDetailStatus.canReceive]: true,
          [ActivityDetailStatus.canComplete]: true,
          [ActivityDetailStatus.toReceive]: true,
          [ActivityDetailStatus.check]: true,
          [ActivityDetailStatus.countdown]: true,
        };
        const activityDetails = details?.activity_details || {};
        // 循环修改状态
        filterActivity.forEach((filterItem) => {
          const item = activityDetails[filterItem.atype];
          if (item) {
            const newStatus: number = Number(
              item.details_status?.new_status || 0,
            );
            if (item.activity_status === 1 && activeStatus[newStatus]) {
              filterItem.status = true;
            } else {
              filterItem.status = false;
            }
          } else {
            filterItem.status = false;
          }
          if (!filterItem.status) {
            filterAtypes[filterItem.atype] = true;
          } else filterAtypes[filterItem.atype] = false;
        });
      } else {
        // const activityCfg = await getActivityConfig(
        //   filterActivity.map((item) => item.atype).join(","),
        // );
        // const activityMaps: Record<number, ActivityConfig> = {};
        // activityCfg.activity_cfg_list?.forEach((item) => {
        //   activityMaps[item.atype] = item;
        // });
        // filterActivity.forEach((filterItem) => {
        //   const item = activityMaps[filterItem.atype];
        //   if (!item || !item.status) {
        //     filterItem.status = false;
        //     filterAtypes[filterItem.atype] = true;
        //   } else {
        //     filterItem.status = true;
        //   }
        // });
      }
    }

    return (
      this.lang_attrs?.list?.filter((item) => {
        let result = true;
        if (item.status !== 1) return false;

        // 登录限制
        if (userStore.isLogin && item?.login_type === LoginType.UnLogged)
          return false;
        if (!userStore.isLogin && item?.login_type === LoginType.Logged)
          return false;
        // 充值限制
        if (
          userStore.userInfo?.is_pay === 1 &&
          item.recharge_type === RechargeType.UnRecharge
        )
          return false;
        if (
          userStore.userInfo?.is_pay === 0 &&
          item.recharge_type === RechargeType.Recharge
        )
          return false;

        // 未登录暂不过滤活动
        if (!userStore.isLogin) {
          // 标签限制
          return getStatusByDeny(item.deny_pack, item.deny_pack_type, true);
        } else {
          // 活动过滤
          if (filterAtypes[item.a_type]) {
            result = filterAtypes[item.a_type]?.status;
          }
          if (result) {
            return getStatusByDeny(item.deny_pack, item.deny_pack_type, true);
          } else return result;
        }
      }) || []
    );
  }

  // /** 获取活动类型 */
  // public getActivityType(): number {
  //   return this.attrs.atype;
  // }
  //
  // /** 设置活动类型 */
  // public setActivityType(type: number): void {
  //   this.setAttrs({ atype: type });
  // }
  //
  // /** 获取标题类型 */
  // public getTitleType(): number {
  //   return this.attrs.title_type;
  // }
  //
  // /** 设置标题类型 */
  // public setTitleType(type: number): void {
  //   this.setAttrs({ title_type: type });
  // }
  //
  // /** 获取标题图标 */
  // public getTitleIcon(): string {
  //   return this.attrs.title_icon;
  // }
  //
  // /** 设置标题图标 */
  // public setTitleIcon(icon: string): void {
  //   this.setAttrs({ title_icon: icon });
  // }
}
